module.exports = __webpack_public_path__ + "media/newstyle/images/logo-google-f72970d314167c3f0b68ff781c869130.png";